import * as React from "react";

import SvgIcon from "@material-ui/core/SvgIcon";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

export const InfoIcon = (props: SvgIconProps) => {
    const {
        viewBox = "0 0 16 16",
        ...rest
    } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <path d="M6.25 1.02419C9.11986 1.02419 11.4758 3.34859 11.4758 6.25C11.4758 9.13607 9.13847 11.4758 6.25 11.4758C3.36506 11.4758 1.02419 9.13963 1.02419 6.25C1.02419 3.36606 3.36134 1.02419 6.25 1.02419ZM6.25 0.25C2.93652 0.25 0.25 2.93749 0.25 6.25C0.25 9.56444 2.93652 12.25 6.25 12.25C9.56348 12.25 12.25 9.56444 12.25 6.25C12.25 2.93749 9.56348 0.25 6.25 0.25ZM5.37903 8.57258H5.66935V5.66935H5.37903C5.2187 5.66935 5.08871 5.53936 5.08871 5.37903V5.18548C5.08871 5.02515 5.2187 4.89516 5.37903 4.89516H6.54032C6.70065 4.89516 6.83064 5.02515 6.83064 5.18548V8.57258H7.12097C7.2813 8.57258 7.41129 8.70257 7.41129 8.8629V9.05645C7.41129 9.21678 7.2813 9.34677 7.12097 9.34677H5.37903C5.2187 9.34677 5.08871 9.21678 5.08871 9.05645V8.8629C5.08871 8.70257 5.2187 8.57258 5.37903 8.57258ZM6.25 2.76613C5.82243 2.76613 5.47581 3.11275 5.47581 3.54032C5.47581 3.9679 5.82243 4.31452 6.25 4.31452C6.67757 4.31452 7.02419 3.9679 7.02419 3.54032C7.02419 3.11275 6.67757 2.76613 6.25 2.76613Z"/>
        </SvgIcon>
    );
};
